import styles from './styles';
import Box, { type BoxProps } from '@material-ui/core/Box';

import { Label } from '@cobliteam/base-components';

interface TitleTourProps {
  title: string;
  description?: string;
  boxProps?: BoxProps;
}

export default function TitleTour({ title, description, boxProps = {} }: TitleTourProps) {
  return (
    <Box padding='md' display='flex' flexDirection='column' {...boxProps}>
      <Box pr={3}>
        <Label className={styles.title}>{title}</Label>
      </Box>
      {description ? <Box>{description}</Box> : null}
    </Box>
  );
}
